import momBus from './vendor/momentBusinessDays'

export const getAdvanceDays = (period: string, value: number) => {
  const periods = `${period.toLowerCase()}s` as momBus.unitOfTime.DurationConstructor
  const startOfPeriod = momBus()
  const endOfPeriod =
    periods === 'days'
      ? (startOfPeriod as any).businessAdd(value)
      : startOfPeriod.add(value, periods)
  let end = endOfPeriod.add(-1, 'seconds')
  if (!end.isBusinessDay()) {
    end = end.prevBusinessDay()
  }
  return end.diff(momBus(), 'days')
}
